
import Vue from "vue";
import IconOverContent from "@/components/common/IconOverContent.vue";
import CloseButton from "@/components/common/CloseButton.vue";
import store from "@/store";
import { VueConstructor } from "vue/types/umd";
import UIFeatureMixinVue from "@/mixins/UIFeatureMixin.vue";
import { UI_ENDPOINT } from "@/constants/EndPoints";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof UIFeatureMixinVue>>
).extend({
  name: "how-to-schedule-trip-content",
  components: { IconOverContent, CloseButton },
  mixins: [UIFeatureMixinVue],
  data() {
    return {
      availableCountiesDialog: false as boolean,
    };
  },
  created() {
    if (this.scheduleCounties.length === 0) {
      let url = UI_ENDPOINT.GET_SCHEDULE_COUNTIES;
      store.dispatch.dataModule.getScheduleCounties(url);
    }
  },
  computed: {
    scheduleCounties() {
      return store.getters.dataModule.getScheduleCountiesInStore;
    },
  },
});
